// isLoggedInService.ts
// export const isLoggedIn = (): boolean => {
//   const accessToken = localStorage.getItem('user');
//   return !!accessToken; // Returns true if accessToken exists, false otherwise
// };

export const isLoggedIn = (): boolean => true; 